import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=c52e2e1a&"
import script from "./ClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=c52e2e1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports